// 4-up stat tile — used on Today, Scanner, Outreach headers.

import type { ReactNode, CSSProperties } from 'react';

interface Props {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  delay?: number;
}

export default function StatTile({ label, value, sub, delay = 0 }: Props) {
  const style: CSSProperties = { animationDelay: `${delay}ms` };
  return (
    <div className="card stat" style={style}>
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
